import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RepoteService {
  private api: string;

  constructor(private http: HttpClient) {
    this.api = environment.wsdlUrl + "reporte/";
  }

  // Retorna Observable con el PDF en ArrayBuffer
  getPdf(params: any, name: string): Observable<ArrayBuffer> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/pdf"
    });

    return this.http.post(this.api + name, params, {
      headers,
      responseType: 'arraybuffer'
    });
  }

  // Método alternativo con Promise, si preferís usar Promise en vez de Observable
  async getReporte(params: any, name: string): Promise<ArrayBuffer | void> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/pdf"
    });

    try {
      return await firstValueFrom(this.http.post(this.api + name, params, {
        headers,
        responseType: 'arraybuffer'
      }));
    } catch (err) {
      console.error("Error en el servicio ", err);
      // Manejo de error adicional
    }
  }
}
